module.exports = __webpack_public_path__ + "img/card-contracts-program-ee-report.ff25b5a8.svg";